import React, { useMemo, useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { Text, Flex, Button, AutoRenewIcon } from 'uikit'
import { useTranslation } from 'contexts/Localization'
import { getBalanceAmount, getDecimalAmount } from 'utils/formatBalance'
import { FormCon, FormLeft, FormInput, Max } from '../styled'
import useWithdrawMultiPool from '../hooks/useWithdrawMultiPool'

interface WithdrawFormProps {
  stakedBalance: BigNumber
}

interface WithdrawButtonProps {
  isWithdrawing?: boolean
}

const WithdrawButton = styled(Button)<WithdrawButtonProps>`
  background: white;
  color: #8e12fc;
  border-radius: 0px 6px 6px 0px;
  height: unset;
  width: ${({ isWithdrawing }) => (isWithdrawing ? '140px' : '100px')};
  font-size: 15px;
`

const WithdrawForm: React.FC<WithdrawFormProps> = ({ stakedBalance }) => {
  const { t } = useTranslation()
  const { isWithdrawing, handleWithdrawMultiPool } = useWithdrawMultiPool()
  const [withdrawAmount, setWithdrawAmount] = useState('')

  const stakedBalanceString = useMemo(
    () => (stakedBalance ? getBalanceAmount(stakedBalance).toString() : '0'),
    [stakedBalance],
  )

  const stakedBalanceDisplay = useMemo(
    () => (stakedBalance ? getBalanceAmount(stakedBalance).toFixed(3) : '0'),
    [stakedBalance],
  )

  const disableWithdraw = useMemo(
    () =>
      withdrawAmount === '' ||
      getDecimalAmount(new BigNumber(withdrawAmount)).isLessThanOrEqualTo(0) ||
      getDecimalAmount(new BigNumber(withdrawAmount)).isGreaterThan(stakedBalance) ||
      isWithdrawing,
    [withdrawAmount, stakedBalance, isWithdrawing],
  )

  return (
    <FormCon>
      <FormLeft>
        <Flex justifyContent="space-between">
          <Text fontSize="15px" fontWeight={300}>
            {t('Your DMD Staked')}
          </Text>
          <Text fontSize="15px" fontWeight={300}>
            {stakedBalanceDisplay}
          </Text>
        </Flex>
        <Flex justifyContent="space-between" mt="2px" alignItems="center">
          <FormInput
            placeholder="0.0"
            value={withdrawAmount}
            onChange={({ target }) => setWithdrawAmount(target.value)}
            type="number"
          />
          <Max onClick={() => setWithdrawAmount(stakedBalanceString)}>{t('Max')}</Max>
        </Flex>
      </FormLeft>
      <WithdrawButton
        disabled={disableWithdraw}
        onClick={() => handleWithdrawMultiPool(withdrawAmount)}
        isLoading={isWithdrawing}
        endIcon={isWithdrawing ? <AutoRenewIcon spin color="currentColor" /> : null}
        isWithdrawing={isWithdrawing}
      >
        {isWithdrawing ? t('Withdrawing') : t('Withdraw')}
      </WithdrawButton>
    </FormCon>
  )
}

export default WithdrawForm
